import { SvgIcon, Link } from "@material-ui/core";
import { ReactComponent as Telegram } from "../../assets/icons/telegram.svg";
import { ReactComponent as Github } from "../../assets/icons/github.svg";
import { ReactComponent as Medium } from "../../assets/icons/medium.svg";
import { ReactComponent as Twitter } from "../../assets/icons/twitter.svg";
import { ReactComponent as Discord } from "../../assets/icons/discord.svg";
import { useDispatch } from "react-redux";
import { t } from "@lingui/macro";
import { info } from "src/slices/MessagesSlice";

export default function Social() {
  const dispatch = useDispatch();

  return (
    <div className="social-row">
      <Link onClick={() => dispatch(info(t`Coming soon`))}>
        <SvgIcon color="primary" component={Discord} />
      </Link>

      <Link href="https://t.me/yapdao" target="_blank">
        <SvgIcon color="primary" component={Telegram} />
      </Link>

      <Link href="https://twitter.com/YAPISLAND_DAO" target="_blank">
        <SvgIcon color="primary" component={Twitter} />
      </Link>

      <Link href="https://medium.com/@Yapdao" target="_blank">
        <SvgIcon color="primary" component={Medium} />
      </Link>
    </div>
  );
}
